import { axiosInstance } from "../services/Axios";
import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { checkLastTimeCheckedAfter3AM, checkWithinTheHour } from "../utils/TimeConversion";
import { handleErrorSentry } from "../utils/constants/Error";

export const broadcastEvent = (eventName, detail) => {
    window.dispatchEvent(new CustomEvent(eventName, { detail }));
};

export const getToken = () => {
    return localStorage.getItem('token');
}

export const getUserID = () => {
    return localStorage.getItem('user_id');
}

export const getFullName = () => {
    return localStorage.getItem('user_full_name');
}

export function getLoginAt() {
    return localStorage.getItem('login_at');
}

export function getEmail() {
    return localStorage.getItem('email');
}

export const clearUser = () => {
    localStorage.setItem('token', null);
    localStorage.setItem('user_id', null);
    localStorage.setItem('user_full_name', null);
    localStorage.setItem('email', null);
    localStorage.setItem('login_at', null)
    broadcastEvent('localStorageChange', { key: 'token', value: null });
}


export async function authGuard () {
    if (checkWithinTheHour(getLoginAt()) && checkLastTimeCheckedAfter3AM(getLoginAt())) {
        return true;
    }

    let status;
    const token = getToken();
    const userID = getUserID();
    const userFullName = getFullName();
    if (token === "null" || userID === "null") {
        return false;
    }
    await axiosInstance.get(`/api/v1/user/${userID}`).then( response => {
        if (userFullName !== response.data.full_name) {
            localStorage.setItem('email', response.data.email);
            localStorage.setItem('user_full_name', response.data.full_name);
        }
        const date = new Date();
        localStorage.setItem('login_at', date.toISOString());
        status = response.status;
    }).catch( error => {
        status = error.status;
    })

    if (status === 200) {
        console.log("Valid Token");
        return true;
    } else {
        console.log("Blocked");
        return false;
    }
}

export async function getGoogleSSOLink() {
    try {
        const response = await axiosInstance.get("/api/login/google");

        return response.data;
    } catch(error) {
        handleErrorSentry(error, "tryCatch");
    }
}

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const [ authState, setAuthState ] = useState(null);

    useEffect(() => {
        const checkAuthState = async () => {
            setAuthState(await authGuard())
        }
        checkAuthState();
    }, [location])

    if (authState === null) {
        return <div> Loading... </div>
    }
    
    if (!authState) {
        return <Navigate to='/login' state={{from: location}} replace/>
    }

    return children
}

ProtectedRoute.propTypes = {
    children: PropTypes.element.isRequired,
}

export default ProtectedRoute